import { render, staticRenderFns } from "./UserProfileAvatar.vue?vue&type=template&id=4e423f60&scoped=true"
import script from "./UserProfileAvatar.vue?vue&type=script&lang=js"
export * from "./UserProfileAvatar.vue?vue&type=script&lang=js"
import style0 from "./UserProfileAvatar.vue?vue&type=style&index=0&id=4e423f60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e423f60",
  null
  
)

export default component.exports